module.exports = __webpack_public_path__ + "assets/media/GIF-Accident@2x.82cf24a1.png";